<template>
  <table class="action-prop-table">
    <tr>
      <th>offer</th>
      <td>{{offerIdStr}}</td>
    </tr>
    <tr>
      <th>action</th>
      <td>{{action}}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'PlayerPendingInfoForceSpecialOffer',

  props: {
    pending: {
      type: Object,
      required: true,
    }
  },

  data() {
    const payload = JSON.parse(this.pending.payload_json);

    return {
      offerIdStr: payload.strid,
      action:     payload.action,
    };
  },
}
</script>
